import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import Checkbox from '../../selectionGroup/checkbox/Checkbox';
import { usePlatformConfig } from '../../../hooks/usePlatformConfig';
import checkboxesStyles from './checkboxes.styles';
const Checkboxes = props => {
    const styles = checkboxesStyles();
    const { id, value, onChange, options, classes, schema, isInCheckout, addDataLayer, } = props;
    const [updatedValues, setUpdatedValues] = useState(value || []);
    const { platformConfig: { checkout }, } = usePlatformConfig();
    const { showCheckboxesLabel } = checkout || {};
    const handleChange = (id, newValue) => {
        if (isInCheckout && addDataLayer)
            addDataLayer(id);
        setUpdatedValues(prevValues => {
            const updatedValues = [...prevValues];
            if (newValue) {
                updatedValues.push(id);
                return updatedValues;
            }
            const index = updatedValues.indexOf(id);
            updatedValues.splice(index, index > -1 ? 1 : updatedValues.length);
            return updatedValues;
        });
    };
    useEffect(() => {
        onChange(updatedValues);
    }, [onChange, updatedValues]);
    return (_jsxs(_Fragment, { children: [showCheckboxesLabel && (_jsx(Typography, { variant: "subtitle1", children: schema.title }, void 0)), _jsx(Box, { className: clsx(styles.root, classes?.root), children: options?.enumOptions.map(({ value: optionValue, label }) => (_jsx(Checkbox, { id: `${id}-${optionValue}`, label: label, onChange: isChecked => handleChange(optionValue, isChecked), value: value.includes(optionValue), classes: {
                        itemRoot: clsx(styles.itemRoot, classes?.itemRoot),
                        item: clsx(styles.item, classes?.item),
                    } }, optionValue))) }, void 0)] }, void 0));
};
export default Checkboxes;
//# sourceMappingURL=Checkboxes.js.map